<!-- error message -->
<div *ngIf="isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.InternalServerError' | translate}}</p>

    </div>
</div>
<div  *ngIf="!isErrorMessage">
    <h2 class="sectionTitle">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.LONGHAUL_REPORT_NAME' | translate }}</h2>
    <div class="services-filter">
      <div class="form-container">
        <h4 class="section-title">{{ 'SHARED.Search' | translate}}</h4>

    <!-- Creation Date From -->
        <div class="form-group">
          <label
            for="txtCreationDateFrom">{{ 'SHARED.REPORTS.EBOOKING_REPORT.REQUEST_SUBMISSION_DATE_FROM' | translate}}</label>
          <input class="form-control" id="txtCreationDateFrom" name="txtCreationDateFrom" autocomplete="off"
            #input="bsDatepicker" [(ngModel)]="creationDateFrom" bsDatepicker [minDate]='null'
            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
          <div class="red" *ngIf="showFromDateGreaterThanTodayDateMessage">
            {{'SHARED.REPORTS.EBOOKING_REPORT.FROM_DATE_GREATER_THAN_TODAY_DATE_MESSAGE' | translate}}
          </div>
          <div class="red" *ngIf="showFromDateGreaterThanToDateMessage">
            {{'SHARED.REPORTS.EBOOKING_REPORT.FROM_DATE_GREATER_THAN_TO_DATE_MESSAGE' | translate}}
          </div>
        </div>
        <!-- Creation Date To -->
        <div class="form-group">
          <label
            for="txtCreationDateTo">{{ 'SHARED.REPORTS.EBOOKING_REPORT.REQUEST_SUBMISSION_DATE_TO' | translate}}</label>
          <input class="form-control" id="txtCreationDateTo" name="txtCreationDateTo" autocomplete="off"
            #input="bsDatepicker" [(ngModel)]="creationDateTo" bsDatepicker [minDate]='null'
            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
        </div>
    <!-- Request Status -->
        <div class="form-group">
          <label for="dllStatus">{{ 'SHARED.MYREQUESTS.Status' | translate}}</label>
          <select class="form-control" id="dllStatus" name="dllStatus" [(ngModel)]="statusId">
            <option value="">--- {{'SHARED.AllStatuses' | translate}} ---</option>
            <option *ngFor="let status of statusesList" value="{{status.Id}}">
              {{currentLanguage == "Ar" ? status.StatusAR : status.StatusEN}}
            </option>
          </select>
        </div>
        <!-- Request Number -->
        <div class="form-group">
          <label for="txtRequestNumber">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.RequestNumber' | translate}}</label>
          <input type="text" class="form-control" [(ngModel)]="requestNumber" autocomplete="off">
        </div>

        <!-- Rebate File Number -->
        <div class="form-group">
          <label for="txtRebateFileNumber">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.RebateFileNumber' | translate}}</label>
          <input type="text" class="form-control" [(ngModel)]="rebateFileNumber" autocomplete="off">
        </div>


          <!-- IMO -->
        <div class="form-group">
          <label for="txtImo">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.Imo' | translate}}</label>
          <input type="text" class="form-control" [(ngModel)]="imo" autocomplete="off">
        </div>
        <!-- Sailing Date -->
        <div class="form-group">
          <label
            for="txtSailingDate">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.SailingDate' | translate}}</label>
          <input class="form-control" id="txtSailingDate" name="txtSailingDate" autocomplete="off"
            #input="bsDatepicker" [(ngModel)]="sailingDate" bsDatepicker [minDate]='null'
            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
        </div>

        <!-- Rebate Percentage From-->
        <div class="form-group">
          <label for="txtRebatePercentageFrom">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.RebatePercentageFrom' | translate}}</label>
          <input  class="form-control"  type="text" (paste)="numericOnly($event)" (keypress)="numericOnly($event)" [(ngModel)]="rebatePercentageFrom" autocomplete="off">


        </div>

                <!-- Rebate Percentage To-->
                <div class="form-group">
                  <label for="txtRebatePercentageTo">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.RebatePercentageTo' | translate}}</label>
                  <input class="form-control" type="text"  (keypress)="numericOnly($event)"  [(ngModel)]="rebatePercentageTo" autocomplete="off">
                </div>

        <!-- Ship Type -->
        <div class="form-group">
            <label for="shipTypeId">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.ShipType' | translate}}</label>
            <select [(ngModel)]="shipTypeId" class="form-control" id="ddlVesselTypeId">
                <option value="" selected>Choose</option>
                <option *ngFor="let vesselType of vesselTypes" [value]="vesselType?.Id" >
                    {{vesselType?.NameEN}}
                </option>
            </select>
        </div>

    <!-- Ship Name  -->
    <div class="form-group">
      <label for="txtShipName">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.VesselName' | translate}}</label>
      <input type="text" class="form-control" [(ngModel)]="shipName" autocomplete="off">
    </div>

    <!-- Operator Name  -->
    <div class="form-group">
        <label for="txtOperatorName">Agent Name</label>
        <input type="text" class="form-control" [(ngModel)]="userName" autocomplete="off">
      </div>
        <!-- <div class="form-group">
          <label for="txtUserName">{{ 'SHARED.REPORTS.LONGHAUL_OBJECT.OperatorName' | translate}}</label>
          <div class="ng-autocomplete">
            <ng-autocomplete [data]="agentsNamesList" [searchKeyword]="keyword" autocomplete="off"
              (selected)='selectAgentNameEvent($event)' (inputChanged)='onAgentsNamesSearchChange($event)'
              (inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate" [minQueryLength]="autoCompleteMinQueryLength"
              [notFoundTemplate]="notFoundTemplate" [isLoading]="isAutoCompleteLoading" [(ngModel)]="userName"
              placeHolder="{{'SHARED.REPORTS.AGENT_NAME_MIN_CHARS' | translate }}">
            </ng-autocomplete>

            <ng-template #itemTemplate let-item>
              <a [innerHTML]="item"></a>
            </ng-template>

            <ng-template #notFoundTemplate let-notFound>
              <div [innerHTML]="this.agentNameNotFoundMessage"></div>
            </ng-template>
          </div>
        </div> -->

        <!-- Last Country of Origin -->
        <div class="form-group">
          <label for="ddlLastCountryOriginId">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.LastCountryOfOrigin' | translate}}</label>
          <select [(ngModel)]=" this.fromCountryId" class="form-control" (change)="onLastCountrySelect($event.target.value)"
            id="ddlLastCountryOriginId">
            <option value="" selected>{{'Choose'| translate}}</option>
            <option *ngFor="let country of countries" [value]="country?.Id">
              {{country?.NameEN}}
            </option>
          </select>
        </div>
        <!-- Last Port of Origin -->
        <div class="form-group">
          <label for="ddlLastPortOriginId">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.LastPortOfOrigin' | translate}}</label>
          <select [(ngModel)]=" fromPortId" class="form-control" id="ddlLastPortOriginId">
            <option value="" selected>{{'Choose'| translate}}</option>
            <option *ngFor="let lastPortOrigin of lastPortsOrigin" [value]="lastPortOrigin?.Id">
              {{lastPortOrigin?.NameEN}}
            </option>
          </select>
        </div>


        <!-- First Country of Destination -->
        <div class="form-group">
          <label for="ddlFirstCountryDestinationId">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.FirstCountryOfDestination' | translate}}</label>
          <select class="form-control" [(ngModel)]=" this.toCountryId" (change)="onFirstCountrySelect($event.target.value)"
            id="ddlFirstCountryDestinationId">
            <option value="" selected>{{'Choose'| translate}}</option>
            <option *ngFor="let country of countries" [value]="country?.Id">
              {{country?.NameEN}}
            </option>
          </select>
        </div>
        <!-- First Port of Destination -->
        <div class="form-group">
          <label for="ddlFirstPortDestinationId">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.FirstPortOfDestination' | translate}}</label>
          <select [(ngModel)]=" this.toPortId" class="form-control" id="ddlFirstPortDestinationId">
            <option value="" selected>{{'Choose'| translate}}</option>
            <option *ngFor="let firstPortDestination of firstPortsDestination" [value]="firstPortDestination?.Id">
              {{firstPortDestination?.NameEN}}
            </option>
          </select>
        </div>


                <!-- Sail Directions -->
                <div class="form-group">
                  <label for="ddlSailDirections">{{ 'SHARED.REPORTS.EBOOKING_REPORT.DIRECTIONS' | translate}}</label>
                  <select [(ngModel)]=" this.directionId" class="form-control" id="ddlSailDirections">
                      <option value="">--- {{'SHARED.REPORTS.EBOOKING_REPORT.ALL_DIRECTIONS' | translate}} ---</option>
                      <option *ngFor="let direction of sailDirections" value="{{direction?.Id}}">
                          {{direction?.Direction}}
                      </option>
                  </select>
              </div>


        <!-- Formulated Decision Date From -->
        <div class="form-group">
          <label
            for="txtformulatedDecisionDateFrom">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.FORMULATED_DECISION_DATE_FROM' | translate}}</label>
          <input class="form-control" id="txtformulatedDecisionDateFrom" name="txtformulatedDecisionDateFrom" autocomplete="off"
            #input="bsDatepicker" [(ngModel)]="formulatedDecisionDateFrom" bsDatepicker [minDate]='null'
            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
          <div class="red" *ngIf="showFormulatedDecisionDateFromGreaterThanTodayDateMessage">
            {{'SHARED.REPORTS.LONGHAUL_REPORT.FORMULATED_DECISION_FROM_DATE_GREATER_THAN_TODAY_DATE_MESSAGE' | translate}}
          </div>
          <div class="red" *ngIf="showFormulatedDecisionFromDateGreaterThanFormulatedDecisionDateToMessage" >
            {{'SHARED.REPORTS.LONGHAUL_REPORT.FORMULATED_DECISION_FROM_DATE_GREATER_THAN_TO_DATE_MESSAGE' | translate}}
          </div>
        </div>
        <!-- Formulated Decision Date From -->
        <div class="form-group">
          <label
            for="txtformulatedDecisionDateTo">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.FORMULATED_DECISION_DATE_TO' | translate}}</label>
          <input class="form-control" id="txtformulatedDecisionDateTo" name="txtformulatedDecisionDateTo" autocomplete="off"
            #input="bsDatepicker" [(ngModel)]="formulatedDecisionDateTo" bsDatepicker [minDate]='null'
            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
        </div>



        <!--Refunded -->
        <div  class="form-group">
            <label for="RefundedCheckbox">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.Refunded' | translate }}</label>
          <div class="custom-checkbox">
            <input type="checkbox"  name="RefundedCheckbox" id="RefundedCheckbox"
            [(ngModel)]="isrefunded">
            <label for="RefundedCheckbox">Yes</label>
          </div>
        </div>

        <!--Ship Passed -->
        <div  class="form-group">
            <label for="ShipPassedCheckbox">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.ShipPassed' | translate }}</label>
          <div class="custom-checkbox">
            <input type="checkbox"  name="ShipPassedCheckbox" id="ShipPassedCheckbox"
            [(ngModel)]="isPassed">
            <label for="ShipPassedCheckbox">Yes</label>
          </div>
        </div>

        <!--Cancelled Requests -->
        <div  class="form-group">
            <label for="CancelledRequestsCheckbox">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.CancelledRequests' | translate }}</label>
          <div class="custom-checkbox">
            <input type="checkbox"  name="CancelledRequestsCheckbox" id="CancelledRequestsCheckbox" (change)="onChangeCancelledRequestsCheckbox($event)"
            [(ngModel)]="isCancelled">
            <label for="CancelledRequestsCheckbox">Yes</label>
          </div>
        </div>

      </div>

     <!-- Cancelled Requests Filters Div -->
    <div *ngIf="showCancelledRequestsFiltersDiv"  class="form-container" id="CancelledRequestsFiltersDiv">
        <!-- Cancelation Date From -->
        <div class="form-group">
            <label
              for="txtCancelationDateFrom">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.CancelationDateFrom' | translate}}</label>
            <input class="form-control" id="txtCancelationDateFrom" name="txtCancelationDateFrom" autocomplete="off"
              #input="bsDatepicker" [(ngModel)]="cancelationDateFrom" bsDatepicker [minDate]='null'
              [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
              <div class="red" *ngIf="showCancelationFromDateGreaterThanCancelationToDateMessage">
                  {{'SHARED.REPORTS.LONGHAUL_REPORT.Cancelation_From_Date_Greater_Than_Cancelation_To_Date_Message' | translate}}
                </div>

          </div>
        <!-- Cancelation Date To -->
        <div class="form-group">
            <label
              for="txtCancelationDateTo">{{ 'SHARED.REPORTS.LONGHAUL_REPORT.CancelationDateTo' | translate}}</label>
            <input class="form-control" id="txtCancelationDateTo" name="txtCancelationDateTo" autocomplete="off"
              #input="bsDatepicker" [(ngModel)]="cancelationDateTo" bsDatepicker [minDate]='null'
              [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
          </div>

    </div>


      <div class="btns-holder text-center">
        <input type="button" class="btn btn-primary SCAcustomBtn" (click)="getLongHaulReportData()"
          value="{{ 'SHARED.Search' | translate}}" />
        <input type="button" class="btn btn-primary SCAcustomBtn" (click)="resetFilters()"
          value="{{ 'SHARED.ResetSearch' | translate}}" />
        <input type="button" *ngIf="!hideExportButton" class="SCAcustomBtn" (click)="EconomicExport()"
          value="{{ 'SHARED.REPORTS.EconomicExport' | translate}}" />
        <input type="button" *ngIf="!hideExportButton" class="SCAcustomBtn" (click)="MeasurementExport()"
          value="{{ 'SHARED.REPORTS.MeasurementExport' | translate}}" />
       <!--   <input type="button" *ngIf="!hideExportButton" class="SCAcustomBtn" (click)="CloseRequests()"
          value="{{ 'SHARED.REPORTS.CloseRequests' | translate}}" />-->
      </div>
    </div>
    <app-grid-view #LongHaulReport [HasMenu]="HasMenu"></app-grid-view>
</div>
